import { getAuthItem } from "../utils/authStorage";

export function getPortalSession() {
  try {
    return JSON.parse(getAuthItem("client") || "{}");
  } catch (_) {
    return {};
  }
}

export function isPortalOwner(session = getPortalSession()) {
  const scope = session?.scope || getAuthItem("scope");
  if (scope) return scope === "owner";
  return session?.portal_role === "owner";
}

/**
 * Module keys enabled for the company's business type, or null when the
 * session has no module list yet (only core, non-module items are shown).
 */
export function getPortalModules(session = getPortalSession()) {
  const list = session?.Enabled_Modules;
  return Array.isArray(list) ? list : null;
}

const ALL_BUSINESS_LEAD_TYPES = ["digital marketing", "sales", "services"];

/** Service-provider companies (DM, Sales, Services) take leads from every business type. */
export function capturesAllBusinessLeads(session = getPortalSession()) {
  if (session?.Captures_All_Business_Leads != null) return !!session.Captures_All_Business_Leads;
  return ALL_BUSINESS_LEAD_TYPES.includes(String(session?.Domain_Name || "").trim().toLowerCase());
}

export function isModuleEnabled(modules, module) {
  if (!module) return true;
  return Array.isArray(modules) && modules.includes(module);
}

/** Hint under login-email inputs: own-domain tenants use @domain, others any email. */
export function portalLoginEmailHint(session = getPortalSession()) {
  const domain = session?.Login_Email_Domain;
  if (domain) {
    return `Used to sign in at office.${domain}. New logins must end with @${domain}.`;
  }
  return "Used to sign in. Any email the person uses (Gmail, Outlook, etc. are fine).";
}

export function canDeleteInPortal(session = getPortalSession()) {
  return isPortalOwner(session);
}

export const canPortalDelete = canDeleteInPortal;
